import { render } from "./RegistrationControlsComponent.vue?vue&type=template&id=7905fda0&scoped=true"
import script from "./RegistrationControlsComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationControlsComponent.vue?vue&type=script&lang=js"

import "./RegistrationControlsComponent.vue?vue&type=style&index=0&id=7905fda0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7905fda0"]])

export default __exports__